import React from 'react';
import {
  SearchByMultiResult,
  SearchByNameResult,
  SearchByOtherResult,
  SearchByPropertyResultItem,
} from 'pages/Search/models';
import { Typography, Row, Col, Divider, Tabs, Icon, Badge } from 'antd';
import SearchExport from 'pages/Search/SearchExport/SearchExport';
import SearchByPropertyResultTabs from '../ResultReports/SearchByPropertyResultTabs';
import SearchByNameResultTabs from '../ResultGrid/SearchByNameResultTabs';
import { SearchByOtherResultTable } from '..';
import { Tabs as TabNames } from 'pages/Search/SearchForm/consts';

const { TabPane } = Tabs;
const { Title } = Typography;

const MultiSearchResults: React.FC<{
  multiResult: SearchByMultiResult | null;
}> = (props: { multiResult: SearchByMultiResult | null }) => {
  const { multiResult } = props;
  const addressResults: SearchByOtherResult[] = [];

  multiResult?.addressResult?.results?.forEach((result) => {
    const resultIndex = result.index;
    addressResults[resultIndex] = addressResults[resultIndex] || {};
    addressResults[resultIndex].results =
      addressResults[resultIndex].results || [];
    addressResults[resultIndex].results.push(result);
  });

  const getTabTitle = (searchBy: string) => {
    if (searchBy === 'environmentalControlBoardJudgments') {
      return 'ECBs by Address';
    } else if (searchBy === 'emergencyRepairs') {
      return 'NYC Emergency Repairs';
    }
  };

  return (
    <>
      <Row type="flex" justify="space-between" align="middle">
        {multiResult && (
          <Col>
            {multiResult.searchByBlockLotSearchCriteria && (
              <Title level={4}>
                Search Criteria: {multiResult.searchByBlockLotSearchCriteria}
              </Title>
            )}
            {multiResult.searchByNameSearchCriteria && (
              <Title level={4}>
                Search Criteria: {multiResult.searchByNameSearchCriteria}
              </Title>
            )}
            {multiResult.searchByAddressSearchCriteria && (
              <Title level={4}>
                Search Criteria: {multiResult.searchByAddressSearchCriteria}
              </Title>
            )}
          </Col>
        )}

        <SearchExport />
        <Divider dashed />
      </Row>

      <Tabs type="card">
        {multiResult?.propertyResult?.results?.length &&
          multiResult.propertyResult.results.map(
            (resultItem: SearchByPropertyResultItem, index: number) => (
              <TabPane
                tab={
                  <>
                    <Icon type="file" />
                    &nbsp;
                    {resultItem.tabTitle}
                  </>
                }
                key={`propertyresult${index}`}
              >
                {resultItem && (
                  <SearchByPropertyResultTabs
                    result={resultItem}
                    searchId={multiResult.searchId}
                  />
                )}
              </TabPane>
            ),
          )}
        {multiResult?.nameResult?.results?.length &&
          multiResult.nameResult.results.map(
            (result: SearchByNameResult, index: number) => (
              <TabPane
                tab={
                  <>
                    <Icon type="file" />
                    &nbsp;
                    {result.header}
                  </>
                }
                key={`nameresult${index}`}
              >
                <SearchByNameResultTabs nameResult={result} />
              </TabPane>
            ),
          )}

        {multiResult &&
          addressResults?.length &&
          addressResults.map((addressResult, resultIndex) => {
            return (
              <TabPane
                tab={
                  <>
                    <Icon type="file" />
                    &nbsp;
                    {addressResult.results[0].addressTabTitle}
                  </>
                }
                key={`addressresult${resultIndex}`}
              >
                <Tabs type="card">
                  {addressResult?.results?.length &&
                    addressResult.results.map(
                      (addressResultItem, resultItemIndex) => {
                        return (
                          <TabPane
                            tab={
                              <>
                                {getTabTitle(addressResultItem.searchBy)}&nbsp;
                                <Badge
                                  showZero={true}
                                  count={addressResultItem.items.length}
                                />
                              </>
                            }
                            key={`${resultItemIndex}`}
                          >
                            <SearchByOtherResultTable
                              result={addressResultItem}
                              tabName={TabNames.Multi}
                              searchId={multiResult.addressResult.searchId}
                              resultType="otherResult"
                            />
                          </TabPane>
                        );
                      },
                    )}
                </Tabs>
              </TabPane>
            );
          })}
      </Tabs>
    </>
  );
};

export default React.memo(MultiSearchResults);
